import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as chart from '../chart'
import * as componentStore from '../component-store'

@ngCore.Component({
  imports: [ds.button.Component, chart.footer.Component],
  providers: [],
  selector: 'atn-mosaic-widget-footer',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component<TType extends ents.core.mosaic.Widget.Type> {
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(componentStore.Widget<TType>)

  /** Exposing widget type enum @see {@link ents.core.mosaic.Widget.Type}  */
  public WidgetTypeEnum = ents.core.mosaic.Widget.Type

  /** @see {@link state.mosaic.endUser.currentRendering.Feature} */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  /**
   * Handles cancel button clicks.
   *
   * __NOTE:__ This button is only displayed when widget is displayed within a
   * `modal` context.
   *
   */
  public cancelClickHandler(): void {
    // REVIEW: accessing currentRendering.modal directly in this component may
    // not be ideal. Alternative approach would be handling this in the modal
    // component, but that would require passing additional props and make
    // conditional handlers more complex
    this.currentRendering.subfeatures.modal.actions.setModal
      .from(`Mosaic.Modal.Widget.Footer.Buttons.Cancel.Clicked`)
      .dispatch({ widgetRef: undefined })
  }

  /**
   * Handles save button clicks.
   *
   * __NOTE:__ This button is only displayed when widget is displayed within a
   * `modal` context.
   */
  public saveButtonClickHandler(): void {
    this.widgetStore.fieldCollection.executeOnSaveAction(
      'Mosaic.Modal.Widget.Footer.Buttons.Save.Clicked',
    )
  }
}
